// removed by extract-text-webpack-plugin
module.exports = {"List":"_2CDsZ18AiH2F7tRgoIYBWU","Header":"_2Tl5t-S2Av37v56kL0Pbfe","green":"_7B0JyQLfQ-1zS_sgIUYWW","orange":"_31yduCIQokmbicB1p7uB-3","red":"_2p-qj2OceXfCIlm4suLBZK","ViewLink":"_3spZCYhONRVj5kbMJwJ4Rf","Row":"MkBT0OtE-jTMdhTiiPEvt"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/TimesheetsList/index.css
// module id = 859
// module chunks = 0